import { ConversationLoaderManager, IConversationLoaderManager } from './ConversationLoaderManager';
import { IPlacerAssistantService } from './PlacerAssistantService';

export interface IConversationsLoaderFactory {
    create(): IConversationLoaderManager;
}

export class ConversationsLoaderFactory implements IConversationsLoaderFactory {
    constructor(private service: IPlacerAssistantService) {
    }

    create(): IConversationLoaderManager {
        return new ConversationLoaderManager(this.service);
    }
}
